import { render, staticRenderFns } from "./ImageBrowserFileInput.vue?vue&type=template&id=4c4e8494&"
import script from "./ImageBrowserFileInput.vue?vue&type=script&lang=js&"
export * from "./ImageBrowserFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports